import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = {
  class: "grid",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pr-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Trường Đại học Giao thông vận tải",
    src: _imports_0,
    class: "max-w-full"
  })
], -1)
const _hoisted_4 = { class: "flex flex-column gap-2 sm:w-full md:w-6" }
const _hoisted_5 = {
  id: "code",
  class: "p-error"
}
const _hoisted_6 = {
  key: 0,
  class: "p-error pt-3"
}
const _hoisted_7 = {
  key: 0,
  class: "card flex justify-content-center"
}

import { ref, onMounted } from "vue";
import Button from "primevue/button";
import Card from "primevue/card";
import { Form, Field } from 'vee-validate';
import InputText from 'primevue/inputtext';
import { schemaNhapHoc } from '@/validations/tracuu.model'
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { MethodResult } from "@/models/MethodResult.model";
import { Nullable } from "primevue/ts-helpers";
import ProgressSpinner from 'primevue/progressspinner';
import ThongBaoTrungTuyen from "@/components/ThongBaoTrungTuyen.vue";

const __default__ = {
  name: "TraCuuNhapHoc",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const model = ref<any>(null);
const loading = ref(false);
const formValue = ref<any>({
  query: null,
  searchId: null,
  searching: false,
  token: null
});
onMounted(async () => {
  await init()
})
const init = async () => {
  const response = await axios.get<MethodResult<any>>(`/search`);
  const data = response.data.data;
  formValue.value.searchId = data?.searchId;
  formValue.value.token = data?.token;
}
const notFoundMessage = ref<Nullable<string>>(null);
const traCuu = async (values: any, actions: any) => {
  loading.value = true;
  formValue.value.searching = false;
  notFoundMessage.value = null;
  model.value = null;
  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
      'X-UTC-TOKEN': formValue.value.token
    }
  }
  await axios.post<MethodResult<any>>(`/search/?query=${formValue.value.query}&searchId=${formValue.value.searchId}`, null, config).then(res => {
    const response = res.data.data;
    if (!response) {
      notFoundMessage.value = 'Thí sinh không trúng tuyển hoặc thông tin tra cứu không chính xác!';
    } else {
      model.value = response.student;
      formValue.value.searching = response.searching;
    }
  }).catch((err: AxiosError) => {
    if (err.response && err.response.status == 429) {
      notFoundMessage.value = 'Bạn đang truy vấn quá nhiều lần. Vui lòng quay lại sau ít phút.';
    } else {
      notFoundMessage.value = 'Máy chủ đang bận vui lòng thử lại sau.';
    }
    console.error(err);
    //window.location.reload();
  }).finally(() => {
    loading.value = false;
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card), { class: "form-container" }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        title: _withCtx(() => [
          _createTextVNode(" TRA CỨU KẾT QUẢ TUYỂN SINH ĐẠI HỌC CHÍNH QUY NĂM 2026")
        ]),
        subtitle: _withCtx(() => [
          _createVNode(_unref(Form), {
            "initial-values": formValue.value,
            "validation-schema": _unref(schemaNhapHoc),
            onSubmit: traCuu
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(Field), {
                  name: "query",
                  "model-value": formValue.value.query
                }, {
                  default: _withCtx(({ field, errorMessage }) => [
                    _createVNode(_unref(InputText), {
                      id: "query",
                      modelValue: formValue.value.query,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValue.value.query) = $event)),
                      type: "text",
                      placeholder: "Nhập CCCD hoặc số báo danh để tra cứu",
                      class: _normalizeClass({ 'p-invalid': errorMessage, 'w-full': true }),
                      "aria-describedby": "code-help"
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("small", _hoisted_5, _toDisplayString(errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createVNode(_unref(Button), {
                  loading: loading.value,
                  label: "Tra cứu",
                  type: "submit",
                  icon: "pi pi-check",
                  class: "sm:w-full md:w-4"
                }, null, 8, ["loading"])
              ]),
              (notFoundMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(notFoundMessage.value), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["initial-values", "validation-schema"])
        ]),
        content: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(ProgressSpinner), { pt: {
              root: {
                style: {
                  zIndex: 9999,
                  height: '70px',
                  width: '70px'
                }
              },
            } })
              ]))
            : _createCommentVNode("", true),
          (formValue.value.searching)
            ? (_openBlock(), _createBlock(ThongBaoTrungTuyen, {
                key: 1,
                item: model.value
              }, null, 8, ["item"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})